export default {
  // Header
  'header.features': 'Features',
  'header.whyDifferent': 'Why Different',
  'header.faq': 'FAQ',
  'header.joinEarlyAccess': 'Join Early Access',

  // Hero Section
  'hero.title.part1': 'Your AI Friend That Saves You From',
  'hero.title.part2': 'Losing Time',
  'hero.description': 'Scrollmate is an AI friend that understands your habits, your goals, and the exact moments when you\'re most vulnerable to',
  'hero.description.highlight': 'endless scrolling',
  'hero.description.part2': '—appearing gently, like a caring friend who helps you pause before the next hour disappears.',
  'hero.joinEarlyAccess': 'Join Early Access',
  'hero.learnMore': 'Learn more',

  // Core Features
  'features.title': '3 Core Features',
  'features.feature1.title': 'It knows your goals.',
  'features.feature1.description': 'You can set goals directly or sync with your calendar. Whether you want to sleep earlier or reduce late-night scrolling, your friend remembers and gently supports those intentions.',
  'features.feature2.title': 'It can intervene in the moment.',
  'features.feature2.description': 'Instead of blocking or scolding, Scrollmate appears right when you\'re stuck in the loop—helping you pause with awareness instead of guilt.',
  'features.feature3.title': 'It understands your habits.',
  'features.feature3.description': 'Scrollmate learns when you tend to lose control—especially at night. It offers timely, caring support during the hours you\'re most vulnerable.',

  // Why Different
  'whyDifferent.title': 'Why Scrollmate Is Different',
  'whyDifferent.notBlocker.title': 'NOT a Blocker',
  'whyDifferent.notBlocker.description': 'Most blockers treat your scrolling as a discipline problem, not a human pattern.',
  'whyDifferent.notReporter.title': 'NOT a Screen-Time Reporter',
  'whyDifferent.notReporter.description': 'Screen-Time Reporters show you the past, but never helps you in the moment when you actually need support.',
  'whyDifferent.whatItIs.title': 'WHAT Scrollmate Truly Is',
  'whyDifferent.whatItIs.point1.title': 'It knows what you want.',
  'whyDifferent.whatItIs.point1.description': 'Your goals, intentions, and the healthier routines you\'re trying to build.',
  'whyDifferent.whatItIs.point2.title': 'It knows when you slip.',
  'whyDifferent.whatItIs.point2.description': 'Your vulnerable hours, especially late at night when it\'s hardest to stop.',
  'whyDifferent.whatItIs.point3.title': 'It knows how to help you pause.',
  'whyDifferent.whatItIs.point3.description': 'Gentle, real-time support instead of pressure, guilt, or hard blocks.',
  'whyDifferent.whatItIs.quote': '"Scrollmate is built around understanding you—not restricting you."',

  // Gallery
  'gallery.image1.label': 'Image #5 – Companion Emotions',
  'gallery.image1.caption': 'A cast of AI characters, each with a unique personality and emotional style.',
  'gallery.image2.label': 'Image #6 – Interface Concept',
  'gallery.image2.caption': 'A relationship-based affinity system that grows stronger as you build healthier habits.',
  'gallery.image3.label': 'Image #7 – Progress Overview',
  'gallery.image3.caption': 'A clear weekly victory dashboard that celebrates your digital wellness achievements.',

  // FAQ
  'faq.title': 'Frequently Asked Questions',
  'faq.q1': 'Does Scrollmate record my screen?',
  'faq.a1': 'No. It detects patterns, not content.',
  'faq.q2': 'Which platforms will it support?',
  'faq.a2': 'We\'re testing browser-based and mobile-first experiences.',
  'faq.q3': 'When will it launch?',
  'faq.a3': 'Early Access members will know first.',

  // Email Signup
  'signup.title': 'Join the Early Access Program',
  'signup.subtitle': 'Be part of the first group to try Scrollmate. You\'ll receive early access, updates, and exclusive features.',
  'signup.emailPlaceholder': 'Enter your email',
  'signup.button': 'Get Early Access',
  'signup.submitting': 'Submitting...',
  'signup.success': 'You\'re in! We\'ll contact you soon.',

  // Footer
  'footer.description': 'Your AI friend that understands your habits and guides you away from phone addiction.',
  'footer.contact': 'Contact',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms',
  'footer.copyright': '© Scrollmate – Built by Noffice Studio.',
  'footer.poweredBy': 'Powered by Readdy',
};
